import Directories from 'components/Directories'
import { PROVIDERS, RESULTS_TYPES } from 'utils/DirectoryParser'

const IndividualsDirectories = (props) => (
  <Directories
    props={props}
    directoryLabel='Individuals'
    directoryProvider={PROVIDERS.INDIVIDUALS}
    directoryBasePath={PROVIDERS.INDIVIDUALS.profilesBasePath}
    directoryResultsType={RESULTS_TYPES.PROFILES}
  />
)

export default IndividualsDirectories
